export default __webpack_public_path__ + "static/media/bannerBig1.c4808fb3.png";